<div class="card">
  <div class="card-header">
    <button class="btn btn-sm btn-primary" (click)="openModal(modalInsertSerial)">
      Adicionar
    </button>
  </div>
  <div class="card align-items-center" *ngIf="circularProgressiveWait">
    <div card="card-body">
      <div class="spinner-border text-primary m-1" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <div class="card-body">
    <table class="table table-fit table-bordered table-hover">
      <thead>
        <tr>
          <th scope="col">Serial</th>
          <th scope="col">Ação</th>
          <th scope="col">Descrição Curta</th>
          <th scope="col">Descrição Longa</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of serialUserList">
          <td class="col-md-2 user-select-all" scope="row">
            {{ item.serial }}
          </td>
          <td class="col-md-1" scope="row">
            <div class="m-2">
              <i-feather
                class="card"
                ngbTooltip="Apagar"
                name="trash-2"
                style="color: red"
                (click)="deleteSerialUser(item.id)"
              ></i-feather>
              <i-feather
                class="card"
                ngbTooltip="Editar"
                name="edit"
                style="color: blue"
                (click)="openModalUpdate(item, modalUpdateSerial)"
              ></i-feather>
            </div>
          </td>
          <td class="col-md-2" scope="row">{{ item.descriptionShort }}</td>
          <td class="col-md-7" style="word-break: break-all" scope="row">
            {{ item.descriptionLong == "null" ? "" : item.descriptionLong }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<!-- <div class="card align-items-center">
  <h4>Em manutenção!</h4>
  <div>
    <img src="../../../../assets/images/manutencao.png"  height="200" width="250" alt="image" />
  </div>
</div> -->
<div class="card">
  <div class="card-header"></div>
  <button
    class="btn btn-sm btn-primary m-2"
    style="align-self: self-start"
    (click)="searchEvents()"
  >
    Pesquisar
  </button>
  <div class="card align-items-center" *ngIf="circularProgressiveWait2">
    <div card="card-body">
      <div class="spinner-border text-primary m-1" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <div class="w-50 m-3">
    <label>Filtar serial</label>

    <ng-select
      id="serialFilterSelect"
      [(ngModel)]="serialFilterSelect"
      [ngModelOptions]="{ standalone: true }"
      [multiple]="true"
      (change)="changeFilterSelect()"
    >
      <ng-option *ngFor="let item of seriaisListFilter" [value]="item.id">
        {{ item.serial }}
      </ng-option>
    </ng-select>
  </div>
  <div class="card overflow-auto">
    <div class="card-body">
      <table class="table table-fit table-bordered">
        <thead class="bg-active text-center text-black border">
          <tr class="table-primary">
            <th>Serial</th>
            <th *ngFor="let item of eventsFilter" scope="col">
              {{ item.event.replace("_", " ").replace("_", " ") }}
            </th>
            <th>Data</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let date of dates; let i = index" scope="row">
            <ng-container *ngFor="let serial of seriaisListSelectComponent">
              <tr [ngClass]="i % 2 ? 'bg-active border' : 'bg-info border'">
                <td class="col-md-2 text-center text-black" scope="row">
                  {{ serial }}
                </td>
                <ng-container *ngFor="let event of eventsFilter">
                  <td class="text-center text-black" scope="row">
                    <a [ngbTooltip]="serial + ' - ' + event.event">{{
                      event.event
                        | serialEvenstCount: date:serial:serialEventsCount
                    }}</a>
                  </td>
                </ng-container>
                <ng-container *ngIf="seriaisListSelectComponent[0] == serial">
                  <td
                    class="col-md-2 text-center text-black"
                    style="vertical-align: middle; text-align: center"
                    [rowSpan]="seriaisListSelectComponent.length"
                    scope="row"
                  >
                    {{ date }}
                  </td>
                </ng-container>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Dialog Insert  new Item -->
<ng-template #modalInsertSerial let-modal>
  <div class="modal-header">
    <h5 class="modal-title mt-0">Novo serial</h5>
    <button
      type="button"
      class="btn btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-hidden="true"
    ></button>
  </div>
  <div class="modal-body">
    <div class="input-group input-group-sm mb-3">
      <span class="input-group-text" id="inputGroup-serial">Serial</span>
      <input
        name="serial"
        [(ngModel)]="serialUserNew.serial"
        type="text"
        class="form-control"
        required
        aria-describedby="inputGroup-serial"
      />
    </div>
    <div class="input-group input-group-sm mb-3">
      <span class="input-group-text" id="inputGroup-descriptionShort"
        >Descrição Curta
      </span>
      <input
        name="descriptionShort"
        [(ngModel)]="serialUserNew.descriptionShort"
        type="text"
        maxlength="50"
        class="form-control"
        aria-describedby="inputGroup-descriptionShort"
      />
    </div>
    <div class="input-group input-group-sm mb-3">
      <span class="input-group-text" id="inputGroup-descriptionLong"
        >Descrição Longa</span
      >
      <div class="form-horizontal w-100">
        <div class="form-group">
          <textarea
            name="descriptionShort"
            [(ngModel)]="serialUserNew.descriptionLong"
            maxlength="250"
            class="form-control"
            rows="5"
          ></textarea>
        </div>
      </div>
    </div>
    <button
      type="submit"
      class="btn btn-primary"
      [disabled]="serialUserNew.serial.length < 1"
      (click)="insertNewSerial(); modal.dismiss('Cross click')"
    >
      Adicionar
    </button>
    <label *ngIf="serialUserNew.serial.length < 1" class="text-danger ms-3">
      Preencha o serial</label
    >
  </div>
</ng-template>

<!-- Dialog Update Item -->
<ng-template #modalUpdateSerial let-modal>
  <div class="modal-header">
    <h5 class="modal-title mt-0">Novo serial</h5>
    <button
      type="button"
      class="btn btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-hidden="true"
    ></button>
  </div>
  <div class="modal-body">
    <div class="input-group input-group-sm mb-3">
      <span class="input-group-text" id="inputGroup-serial">Serial</span>
      <input
        name="serial"
        [(ngModel)]="serialUserUpdate.serial"
        type="text"
        class="form-control"
        required
        aria-describedby="inputGroup-serial"
      />
    </div>
    <div class="input-group input-group-sm mb-3">
      <span class="input-group-text" id="inputGroup-descriptionShort"
        >Descrição Curta
      </span>
      <input
        name="descriptionShort"
        [(ngModel)]="serialUserUpdate.descriptionShort"
        type="text"
        maxlength="50"
        class="form-control"
        aria-describedby="inputGroup-descriptionShort"
      />
    </div>
    <div class="input-group input-group-sm mb-3">
      <span class="input-group-text" id="inputGroup-descriptionLong"
        >Descrição Longa</span
      >
      <div class="form-horizontal w-100">
        <div class="form-group">
          <textarea
            name="descriptionShort"
            [(ngModel)]="serialUserUpdate.descriptionLong"
            maxlength="250"
            class="form-control"
            rows="5"
          ></textarea>
        </div>
      </div>
    </div>
    <button
      type="submit"
      class="btn btn-primary"
      [disabled]="serialUserUpdate.serial.length < 1"
      (click)="updateSerialUser(); modal.dismiss('Cross click')"
    >
      Salvar
    </button>
    <label *ngIf="serialUserUpdate.serial.length < 1" class="text-danger ms-3">
      Preencha o serial</label
    >
  </div>
</ng-template>
